// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Unzd","item":"PaymentsMobile_item__3Pipb","label":"PaymentsMobile_label__1JtcM","amount":"PaymentsMobile_amount__gvRkf"};